import useEmblaCarousel from "embla-carousel-react";
import {EmblaOptionsType} from "embla-carousel";
import {useEmblaNavigation} from "@/shared/lib/embla/useEmblaNavigation";

export const useMainBlogCarousel = () => {
    const options: EmblaOptionsType = {
        align: "start",
    }

    const [carouselRef, carouselApi] = useEmblaCarousel(options);

    const navigation = useEmblaNavigation(carouselApi);

    return {
        carouselRef,
        ...navigation,
    };
}
